export default {
  '请求': {
    '加载中': 'Chargement',
    '请求失败': 'Échec de la requête',
    '登录已过期': 'Session expirée',
    '网络连接失败': 'Échec de connexion réseau',
    '请重新登录': 'Veuillez vous reconnecter',
    '没有权限访问': 'Accès refusé',
    '请求的资源不存在': 'Ressource introuvable',
    '服务器错误': 'Erreur serveur',
    '网络错误': 'Erreur réseau',
    '刷新成功': 'Actualisé',
    '获取中': 'Chargement......',
    '账号下线': 'Compte hors ligne',
    '功能已禁用': 'Fonctionnalité désactivée',
  },
  '导航': {
    '首页': 'Accueil',
    '选妃': 'Choisir',
    '认证': 'Vérifier',
    '影院': 'Vidéo',
    '个人': 'Moi',
  },
  '首页': {
    '注册': "S'inscrire",
    '影片': 'Vidéo',
    '女团': 'Filles',
    '热门城市': 'Villes populaires :',
    '经理预订': 'Réservation manager',
    '看更多': 'Plus',
    '身份验证': 'Vérifié',
    '身高': 'Taille',
    '胸围': 'Poitrine',
    '服务城市': 'Ville :',
  },
  '女团': {
    '女团': 'Filles',
    '选妃': 'Choisir',
    '身份验证': 'Vérifié',
    '身高': 'Taille',
    '胸围': 'Poitrine',
    '服务城市': 'Ville :',
    '注册': "S'inscrire",
    '请联系顾问或接待员': 'Veuillez contacter un conseiller',
  },
  '登录': {
    '登录会员视窗': 'Connexion membre',
    '请输入用户名': "Nom d'utilisateur",
    '请输入密码': 'Mot de passe',
    '登录': 'Connexion',
    '没有账号马上注册': 'Pas de compte ? Inscrivez-vous',
    '登录成功': 'Connexion réussie',
    '登录注册': 'Connexion / Inscription',
    '登录可享受更多服务': 'Connectez-vous pour plus de services !',
  },
  '注册': {
    '注册': "S'inscrire",
    '登录': 'Connexion',
    '请输入用户名': "Nom d'utilisateur",
    '用户名规则': '6-20 lettres/chiffres',
    '请输入密码': 'Mot de passe',
    '密码规则': '6-16 lettres et chiffres',
    '请输入验证码': 'Captcha',
    '验证码规则': 'Saisir le captcha à 4 caractères',
    '请输入邀请码': "Code d'invitation",
    '邀请码规则': "Saisir le code d'invitation agent",
    '同意协议': "J'ai 18 ans et plus et j'accepte les conditions",
    '立即注册': "S'inscrire maintenant",
    '注册中': 'Inscription...',
    '已有账号马上登录': 'Déjà un compte ? Connexion',
    '注册成功': 'Inscrit !',
    '注册失败': "Échec de l'inscription : ",
    '验证码错误': 'Captcha invalide',
    '请同意注册条款': 'Veuillez accepter les conditions',
    '用户名已存在': "Nom d'utilisateur déjà pris",
    '邀请码无效': "Code d'invitation invalide",
  },
  '抢单': {
    '今日收益': 'Revenus du jour',
    '余额': 'Solde',
    '订单': 'Commandes',
    '开始抢单': 'Prendre une commande',
    '当前等级': 'Niveau :',
    '提现': 'Retrait',
    '在线客服': 'Support',
    '充值': 'Recharger',
    '幸运任务': 'Tâche chanceuse',
    '幸运订单': 'Commande chanceuse',
    '幸运订单提示': 'Bravo ! Commande à commission élevée',
    '恭喜获得幸运订单': 'Commande chanceuse obtenue !',
    '提交订单': 'Soumettre la commande',
    '未完成订单提示': "Vous avez une commande impayée. Veuillez d'abord payer.",
    '正在获取订单': 'Chargement de la commande...',
    '抢单时间': 'Heure de prise :',
    '订单号': 'N° de commande',
    '订单总额': 'Total',
    '佣金': 'Commission',
    '商品单价': 'Prix',
    '预计收入': 'Gains estimés',
    '确认支付': 'Payer maintenant',
    '确认付款': 'Confirmer le paiement',
    '支付处理中': 'Traitement...',
    '取消': 'Annuler',
    '去查看': 'Voir',
    '暂无可用订单': 'Aucune commande disponible',
    '正在加载用户信息': 'Chargement des infos utilisateur...',
    '今日抢单已达上限': 'Limite quotidienne atteinte',
    '余额不足无法获取订单': 'Solde insuffisant',
    '获取订单失败': 'Échec de récupération de la commande',
    '支付成功': 'Paiement réussi',
    '支付失败': 'Échec du paiement',
    '支付失败请重试': 'Échec du paiement, veuillez réessayer',
    '请完成任务单后进入': "Veuillez d'abord terminer les tâches",
    '请设置收款卡': 'Veuillez lier une adresse de retrait',
  },
  '我的': {
    '我的页面': 'Ma page',
    '钻石': 'Diamant',
    '信誉分': 'Crédit',
    '开通专属会员': 'Ouvrir VIP',
    '开启一次日期不限': 'Déblocage unique, sans limite de date',
    '提现': 'Retrait',
    '历史订单': 'Historique des commandes',
    '充值记录': 'Historique des recharges',
    '提现记录': 'Historique des retraits',
    '添加钱包地址': 'Ajouter une adresse de portefeuille',
    '邀请码': "Code d'invitation :",
    '余额': 'Solde',
    '退出登陆': 'Déconnexion',
  },
  '会员': {
    '会员等级': 'Abonnement :',
    '普通等级': 'Normal',
    '当前等级': 'Actuel',
    '立即开通': 'Activer',
    '免费说明': '(Vidéos gratuites) (Matching gratuit)',
    '所需投资': 'Investissement requis',
    '佣金': 'Commission',
    '订单': 'Commandes',
    '加入': 'Rejoindre >>',
  },
  '充值': {
    '充值': 'Recharger',
    '当前余额': 'Solde',
    '余额': 'Solde : ',
    '个': '',
    '充值金额': 'Montant',
    '请输入充值金额': 'Saisir le montant',
    '快速选择金额': 'Montant rapide',
    '确认': 'Confirmer',
    '提示': 'Conseil',
    '金额错误': 'Montant invalide',
    '立即充值': 'Recharger maintenant',
    '提交成功': 'Soumis, en attente de validation',
  },
  '提现': {
    '提现': 'Retrait',
    '兑换积分': 'Retirer des points',
    '最大提款金额': 'Montant max',
    '资金密码': 'Mot de passe des fonds',
    '余额': 'Solde : ',
    '个': '',
    '钱包地址': 'Adresse du portefeuille : ',
    '请选择提款地址': "Sélectionner l'adresse de retrait",
    '暂无绑定地址': 'Aucune adresse liée',
    '提交': 'Soumettre',
    '通知': 'Avis :',
    '单笔最大提现': '1. Max par retrait : ',
    '单笔最低提现': '2. Min par retrait : ',
    '检查姓名账号': '3. Vérifiez votre nom et votre compte',
    '注意提款费用': '4. Attention aux frais de retrait',
    '请填写正确的金额': 'Saisir un montant valide',
    '当前余额': 'Solde',
    '提现金额': 'Montant',
    '请输入提现数量': 'Saisir le montant',
    '立即提现': 'Retirer maintenant',
    '交易密码': 'Mot de passe de paiement',
    '请输入交易密码': 'Saisir le mot de passe de paiement',
    '请先设置提现密码': "Veuillez d'abord définir le mot de passe de retrait",
  },
  '绑卡': {
    '添加钱包地址': 'Ajouter une adresse de portefeuille',
    '钱包地址信息': 'Infos du portefeuille',
    '请输入支付卡信息': 'Saisir votre adresse de portefeuille',
    '加密货币类型': 'Type de crypto',
    '请选择加密货币类型': 'Sélectionner le type de crypto',
    '钱包地址': 'Adresse du portefeuille',
    '请输入钱包地址': "Saisir l'adresse du portefeuille",
    '绑卡说明': 'Cher utilisateur, pour la sécurité de vos fonds, veuillez lier votre vrai nom et définir un mot de passe de retrait. Le nom doit correspondre au compte.',
    '确定绑卡': 'Confirmer la liaison',
    '绑卡提示': 'Conseil : liez une grande banque. Contactez le support pour modifier.',
    '请先设置姓名': "Veuillez d'abord définir votre nom !",
    '已绑定不可修改': 'Adresse déjà liée. Contactez le support pour modifier.',
  },
  '订单历史': {
    '订单历史': 'Historique des commandes',
    '数据为空': 'Aucune donnée',
    '订单号': 'N° de commande : ',
    '已完成': 'Terminé',
    '处理中': 'En cours',
    '完成订单': 'Terminer la commande',
    '订单金额': 'Montant : ',
    '佣金': 'Commission : ',
    '创建时间': 'Créé : ',
    '上一页': 'Préc.',
    '下一页': 'Suiv.',
    '获取失败': "Échec du chargement de l'historique",
    '获取失败重试': 'Échec du chargement, veuillez réessayer',
    '未知': 'Inconnu',
    '完成成功': 'Commande terminée !',
    '完成失败': 'Échec de la finalisation : ',
    '完成失败重试': 'Échec de la finalisation, veuillez réessayer',
    '请输入支付密码': 'Entrez le mot de passe de paiement',
    '请先设置支付密码': 'Veuillez d\'abord définir le mot de passe de paiement',
  },
  '入金记录': {
    '标题': 'Historique des recharges',
    '数据为空': 'Aucune donnée',
    '认证结果': 'Résultat',
    '下单积分': 'Points : ',
    '下单时间': 'Commandé : ',
    '结算时间': 'Réglé : ',
    '待审核': 'En attente',
    '已通过': 'Approuvé',
    '已拒绝': 'Refusé',
    '暂无数据': 'Aucune donnée',
  },
  '提现记录': {
    '标题': 'Historique des retraits',
    '数据为空': 'Aucune donnée',
    '待审核': 'En attente',
    '审核成功': 'Approuvé',
    '审核退回': 'Refusé',
    '未知状态': 'Inconnu',
    '金额': 'Montant : ',
    '说明': 'Note : ',
    '提交时间': 'Soumis : ',
    '审核时间': 'Examiné : ',
    '已通过': 'Approuvé',
    '已拒绝': 'Refusé',
    '暂无数据': 'Aucune donnée',
  },
  '资料': {
    '基本信息': 'Profil',
    '头像': 'Avatar',
    '姓名': 'Nom',
    '未设置': 'Non défini',
    '性别': 'Sexe',
    '男': 'Homme',
    '女': 'Femme',
    '未知': 'Inconnu',
    '设定': 'Paramètres',
    '账号信息': 'Compte',
    '更改登录密码': 'Changer le mot de passe de connexion',
    '设定支付密码': 'Définir le mot de passe de paiement',
    '退出登录': 'Déconnexion',
    '设置': 'Paramètres',
    '登录密码': 'Mot de passe de connexion',
    '资金密码': 'Mot de passe des fonds',
    '提现密码已设置': 'Mot de passe de retrait défini. Contactez le support pour modifier.',
    '已设置': 'Défini',
    '修改真实姓名': 'Modifier le nom réel',
    '请输入真实姓名': 'Saisir le nom réel',
    '真实姓名说明': 'Le nom réel doit correspondre aux infos du portefeuille',
    '提交': 'Soumettre',
    '请勿重复设置': 'Déjà défini !',
    '修改登录密码': 'Changer le mot de passe de connexion',
    '设置资金密码': 'Définir le mot de passe des fonds',
    '保存': 'Enregistrer',
    '旧密码': 'Ancien mot de passe',
    '请输入旧密码': "Saisir l'ancien mot de passe",
    '新密码': 'Nouveau mot de passe',
    '请输入新密码': 'Saisir le nouveau mot de passe',
    '确认密码': 'Confirmer le mot de passe',
    '请再次输入新密码': 'Saisir à nouveau le nouveau mot de passe',
    '请填写完整': 'Veuillez remplir tous les champs !',
    '两次密码不一致': 'Les mots de passe ne correspondent pas',
    '性别修改': 'Modifier le sexe',
    '个人报表': 'Rapport personnel',
    '任务金额积分': 'Montant des tâches (points)',
    '盈利公式': 'Profit = Gain − Montant des tâches',
    '任务金额': 'Montant des tâches',
    '充值金额': 'Recharge',
    '金额': 'Montant',
    '中奖金额': 'Montant gagné',
    '个人情报': 'Profil',
    '身高': 'Taille :',
    '胸围': 'Poitrine :',
    '收费区间': 'Fourchette de prix :',
    '系统公告': 'Annonces',
  },
  '客服': {
    '联系客服': 'Contacter le support',
    '在线客服': 'Support en ligne',
    '暂无客服': 'Aucun support disponible',
    '联系': 'Contacter',
    '服务时间': 'À votre service 24h/24 et 7j/7',
  },
  '影院': {
    '影院': 'Cinéma',
    '全部': 'Tout',
    '最高分': 'Mieux notés',
    '播放': 'Lectures : ',
    '次播放': ' lectures',
    '热门推荐': 'Populaire',
    '播放次数': 'Lectures :',
    '请充值后观看': 'Veuillez recharger pour regarder',
  },
  '语言切换器': {
    '切换语言': 'Langue',
    '语言': 'Langue',
  },
}
